export default __webpack_public_path__ + "pgnv-assets/1372cdf1c25d48e41275f9eaf5d3403e.png";